import { render, staticRenderFns } from "./fbxt.vue?vue&type=template&id=0c19a101&scoped=true"
import script from "./fbxt.vue?vue&type=script&lang=js"
export * from "./fbxt.vue?vue&type=script&lang=js"
import style0 from "./fbxt.vue?vue&type=style&index=0&id=0c19a101&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c19a101",
  null
  
)

export default component.exports